export function validatePreopen(config) {
    const qty = Number(config.expectedQuantity);
    if (!Number.isFinite(qty) || qty <= 0) {
        return "Expected quantity must be > 0.";
    }

    const p = config.preopen;
    if (!p) return "preopen config is required.";

    if (!p.preopenOrderDate || !String(p.preopenOrderDate).trim())
        return "Preopen order date is required.";

    const mode = String(p.preopenPriceMode || "CIRCUIT").toUpperCase();
    if (mode !== "CIRCUIT" && mode !== "CUSTOM") {
        return "preopenPriceMode must be CIRCUIT or CUSTOM.";
    }

    if (mode === "CUSTOM") {
        const cp = Number(p.preopenCustomPrice);
        if (!Number.isFinite(cp) || cp <= 0) return "Custom preopen price must be > 0.";
    }

    const totalOrders = Number(p.preopenTotalOrders);
    if (!Number.isFinite(totalOrders) || totalOrders <= 0) {
        return "Total number of orders must be > 0.";
    }

    const rpt = p.preopenRepeatTillDays;
    if (rpt !== null && rpt !== undefined && rpt !== "") {
        const r = Number(rpt);
        if (!Number.isFinite(r) || r < 0) return "Repeat till days must be ≥ 0.";
    }

    return null;
}
